/* ==========================================================================
   New Product Grid — add to cart + quantity stepper
   Added by Cowork. Standalone: does not modify or depend on native theme JS,
   but will talk to the theme's cart drawer / pub-sub when they are present.
   ========================================================================== */
(function () {
  if (window.NpgCart) return;

  var ROUTES = window.routes || {};
  var ADD_URL = ROUTES.cart_add_url || '/cart/add';
  var CHANGE_URL = ROUTES.cart_change_url || '/cart/change';
  var CART_URL = ROUTES.cart_url || '/cart';

  var NpgCart = {
    instances: [],
    state: {}, // variantId -> { key, quantity }
    loaded: false,

    register: function (el) {
      this.instances.push(el);
      if (this.loaded) el.sync(this.state[el.variantId]);
      else this.load();
    },

    unregister: function (el) {
      var i = this.instances.indexOf(el);
      if (i > -1) this.instances.splice(i, 1);
    },

    load: function () {
      if (this._loading) return this._loading;
      var self = this;
      this._loading = fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.absorb(cart); })
        .catch(function () { self.loaded = true; })
        .finally(function () { self._loading = null; });
      return this._loading;
    },

    absorb: function (cart) {
      var next = {};
      (cart && cart.items ? cart.items : []).forEach(function (item) {
        var id = String(item.variant_id);
        if (next[id]) next[id].quantity += item.quantity;
        else next[id] = { key: item.key, quantity: item.quantity };
      });
      this.state = next;
      this.loaded = true;
      this.paint();
    },

    paint: function () {
      var self = this;
      this.instances.forEach(function (el) { el.sync(self.state[el.variantId]); });
    },

    drawer: function () { return document.querySelector('cart-drawer'); },

    sectionIds: function () {
      var d = this.drawer();
      if (d && typeof d.getSectionsToRender === 'function') {
        try {
          return d.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        } catch (e) { /* noop */ }
      }
      return '';
    },

    // Tell the rest of the theme something changed, without forcing the drawer open.
    broadcast: function (response, openDrawer) {
      var d = this.drawer();
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'new-product-grid', cartData: response });
        }
      } catch (e) { /* noop */ }

      if (d && typeof d.renderContents === 'function' && response && response.sections) {
        try {
          if (d.classList.contains('is-empty')) d.classList.remove('is-empty');
          d.renderContents(response, !openDrawer);
        } catch (e) { /* noop */ }
      }

      document.dispatchEvent(new CustomEvent('cart-drawer:refresh', {
        detail: { response: response }, bubbles: true
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    },

    add: function (variantId, openDrawer) {
      var self = this;
      var body = { items: [{ id: variantId, quantity: 1 }] };
      var sections = this.sectionIds();
      if (sections) { body.sections = sections; body.sections_url = window.location.pathname; }

      return fetch(ADD_URL + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status && res.status !== 200) throw new Error(res.description || res.message);
          self.broadcast(res, openDrawer);
          return self.load();
        });
    },

    change: function (variantId, quantity, openDrawer) {
      var self = this;
      var entry = this.state[variantId];
      if (!entry) return this.add(variantId, openDrawer);

      var body = { id: entry.key, quantity: Math.max(0, quantity) };
      var sections = this.sectionIds();
      if (sections) { body.sections = sections; body.sections_url = window.location.pathname; }

      return fetch(CHANGE_URL + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          self.broadcast(res, openDrawer);
          if (res && res.items) self.absorb(res);
          else self.load();
          return res;
        });
    }
  };

  window.NpgCart = NpgCart;

  // Keep in sync when anything else on the page changes the cart.
  ['cart:refresh', 'cart-drawer:refresh', 'cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (e && e.detail && e.detail.source === 'new-product-grid') return;
      setTimeout(function () { NpgCart.load(); }, 350);
    });
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    try {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
        if (data && data.source === 'new-product-grid') return;
        setTimeout(function () { NpgCart.load(); }, 350);
      });
    } catch (e) { /* noop */ }
  }

  /* ------------------------------------------------------------------------
     Mobile filter drawer safety net.

     collection-section.js opens the drawer from a document-level listener that
     only fires when e.target IS the trigger element:
         triggerClasses.some(cls => e.target.classList.contains(cls))
     A tap that lands on the icon, the label text or the active-count badge
     therefore does nothing at all. CSS sets pointer-events:none on the
     children, and this listener is the belt to that pair of braces — it works
     even if a future theme update reintroduces pointer events on the icon.
     ------------------------------------------------------------------------ */
  function npgFilterTriggerHandler(e) {
    if (!e.target || !e.target.closest) return;
    var trigger = e.target.closest('.npg .collection__filter-trigger');
    if (!trigger) return;

    // The theme's own handler already covers a tap directly on the trigger.
    if (e.target === trigger) return;

    var section = trigger.closest('collection-section');
    if (!section || typeof section.toggleDrawer !== 'function') return;
    if (!section.currentDrawerMode) return; // desktop: sidebar is already visible

    section.toggleDrawer(e);
  }

  document.addEventListener('click', npgFilterTriggerHandler);

  // The trigger is a div with role="button", so give it real keyboard support.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    if (!e.target || !e.target.closest) return;
    var trigger = e.target.closest('.npg .collection__filter-trigger');
    if (!trigger) return;
    var section = trigger.closest('collection-section');
    if (!section || typeof section.toggleDrawer !== 'function') return;
    if (!section.currentDrawerMode) return;
    e.preventDefault();
    section.toggleDrawer(e);
  });

  if (!customElements.get('npg-atc')) {
    customElements.define('npg-atc', class NpgAtc extends HTMLElement {
      connectedCallback() {
        this.variantId = this.dataset.variantId;
        this.openDrawer = this.dataset.openDrawer === 'true';
        this.btn = this.querySelector('.npg-atc__btn');
        this.qtyEl = this.querySelector('.npg-atc__qty');
        this.decEl = this.querySelector('.npg-atc__dec');
        this.incEl = this.querySelector('.npg-atc__inc');
        this.binIcon = this.dataset.iconBin || '';
        this.minusIcon = this.dataset.iconMinus || '';

        this.onAdd = this.onAdd.bind(this);
        this.onInc = this.onInc.bind(this);
        this.onDec = this.onDec.bind(this);

        if (this.btn && !this.btn.hasAttribute('disabled')) this.btn.addEventListener('click', this.onAdd);
        if (this.incEl) this.incEl.addEventListener('click', this.onInc);
        if (this.decEl) this.decEl.addEventListener('click', this.onDec);

        NpgCart.register(this);
      }

      disconnectedCallback() { NpgCart.unregister(this); }

      get quantity() { return parseInt(this.qtyEl ? this.qtyEl.textContent : '0', 10) || 0; }

      sync(entry) {
        var qty = entry ? entry.quantity : 0;
        this.dataset.inCart = qty > 0 ? 'true' : 'false';
        if (this.qtyEl) this.qtyEl.textContent = qty > 0 ? qty : 1;
        if (this.decEl) this.decEl.innerHTML = qty > 1 ? this.minusIcon : this.binIcon;
        if (this.btn) this.btn.classList.remove('is-loading');
        this.removeAttribute('aria-busy');
      }

      busy() { this.setAttribute('aria-busy', 'true'); if (this.btn) this.btn.classList.add('is-loading'); }

      onAdd(e) {
        e.preventDefault();
        if (this.hasAttribute('aria-busy')) return;
        this.busy();
        NpgCart.add(this.variantId, this.openDrawer).catch(() => this.sync(NpgCart.state[this.variantId]));
      }

      onInc(e) {
        e.preventDefault();
        if (this.hasAttribute('aria-busy')) return;
        this.busy();
        NpgCart.change(this.variantId, this.quantity + 1, false).catch(() => this.sync(NpgCart.state[this.variantId]));
      }

      onDec(e) {
        e.preventDefault();
        if (this.hasAttribute('aria-busy')) return;
        this.busy();
        NpgCart.change(this.variantId, this.quantity - 1, false).catch(() => this.sync(NpgCart.state[this.variantId]));
      }
    });
  }
})();
